import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import MergeTypeOutlinedIcon from "@mui/icons-material/MergeTypeOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PageContentShell } from "../../components/layout/PageContentShell";
import { PageHeader } from "../../components/Page/PageHeader";
import { StatCard } from "../../components/StatCard";
import { ticketService, type Stats } from "../../services/ticketService";

export function AdminDashboardPage() {
  const { t } = useTranslation();
  const [stats, setStats] = useState<Stats | null>(null);

  useEffect(() => {
    void ticketService.adminStats().then(setStats);
  }, []);

  const cards = [
    { label: t("admin.total"), value: stats?.total ?? "—", icon: <ConfirmationNumberOutlinedIcon /> },
    { label: t("home.open"), value: stats?.openCount ?? "—", icon: <ConfirmationNumberOutlinedIcon /> },
    { label: t("home.merged"), value: stats?.mergedCount ?? "—", icon: <MergeTypeOutlinedIcon /> },
    { label: t("admin.benefitAvg"), value: stats?.averageBenefitScore ?? "—", icon: <TrendingUpOutlinedIcon /> },
    { label: t("admin.agentOk"), value: stats?.agentSuccessCount ?? "—", icon: <SmartToyOutlinedIcon /> },
    { label: t("admin.agentFailed"), value: stats?.agentFailedCount ?? "—", icon: <ErrorOutlineIcon /> },
  ];

  return (
    <PageContentShell>
      <PageHeader title={t("nav.dashboard")} subtitle={t("admin.subtitle")} />
      <Grid container spacing={2}>
        {cards.map((card) => (
          <Grid key={card.label} size={{ xs: 12, sm: 4 }}>
            <StatCard icon={card.icon} label={card.label} value={card.value} />
          </Grid>
        ))}
      </Grid>
    </PageContentShell>
  );
}
